/* with love from shopstory */
'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

const buttonOptionalIconSchemaProp = {
  prop: "symbol",
  label: "Symbol",
  type: "component",
  accepts: ["symbol"],
  visible: true,
  group: "Properties"
};
const buttonRequiredIconSchemaProp = {
  ...buttonOptionalIconSchemaProp,
  required: true
};

exports.buttonOptionalIconSchemaProp = buttonOptionalIconSchemaProp;
exports.buttonRequiredIconSchemaProp = buttonRequiredIconSchemaProp;
